import React from "react";
import {NavLink} from "react-router-dom";
import {selectIsLoggedIn} from "@src/features/auth/redux/auth-slice";
import {AppStoreLink, PlayStoreLink} from "@src/ui/views/store-link";
import {useAppSelector} from "@src/integrations/redux/redux-store";


export function HomeScreen() {
	const isLoggedIn = useAppSelector(selectIsLoggedIn);
	
	if (isLoggedIn) {
		return (
			<div>
				<h1>
					Welcome to your Cherri Dashboard!
				</h1>
				<NavLink
					to="/dashboard"
					className="transition-colors hover:text-foreground text-foreground">
					Go to Dashboard
				</NavLink>
			</div>
		);
	}
	
	return (
		<div>
			<h1>
				Welcome to your Cherri Dashboard!
			</h1>
			<NavLink
				to="/auth/login"
				className="transition-colors hover:text-foreground text-foreground">
				Log In
			</NavLink>
			<h3>
				The dashboard is for admins. If you're new to Cherri, create a new account using our apps:
			</h3>
			<div className="flex flex-col items-center space-y-4 p-4">
				<AppStoreLink/>
				<PlayStoreLink/>
			</div>
		</div>
	);
}
